import React from 'react';
import { useTheme } from './ThemeContext';

const ThemeTest = () => {
  const { theme, changeTheme } = useTheme();
  
  return (
    <div className="p-4 space-y-4">
      <h2 className="text-xl font-bold text-theme-primary">Theme Test Component</h2>
      
      <div className="space-y-2">
        <div className="p-4 bg-theme-card border-theme-light border rounded">
          <h3 className="text-theme-primary font-semibold">Card with Theme Colors</h3>
          <p className="text-theme-secondary">This should use theme colors</p>
          <p className="text-theme-tertiary text-sm">Tertiary text color</p>
        </div>
        
        <div className="flex gap-2">
          <button className="btn-primary">Primary Button</button>
          <button className="btn-secondary">Secondary Button</button>
          <button className="btn-danger">Danger Button</button>
        </div>
        
        <div className="flex gap-2">
          <span className="status-badge status-active">Active</span>
          <span className="status-badge status-pending">Pending</span>
          <span className="status-badge status-error">Error</span>
        </div>
        
        <div className="p-4 bg-theme-primary-50 border-theme-primary border rounded">
          <p className="text-theme-primary">Primary 50 background with primary text</p>
        </div>
        
        <div className="space-y-2">
          <div className="text-sm text-theme-secondary">
            <strong>Current Theme:</strong> {theme}
          </div>
          <div className="flex gap-2">
            <button 
              onClick={() => changeTheme('light')}
              className="btn-primary text-sm"
            >
              Set Light Theme
            </button>
            <button 
              onClick={() => changeTheme('dark')}
              className="btn-secondary text-sm"
            >
              Set Dark Theme
            </button>
            <button 
              onClick={() => changeTheme('blue')}
              className="btn-secondary text-sm"
            >
              Set Blue Theme
            </button>
            <button 
              onClick={() => changeTheme('green')}
              className="btn-secondary text-sm"
            >
              Set Green Theme
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThemeTest;
